import { ClassificationStatus } from '../Features/Classification/enum/ClassificationStatus';
import { NewsStatus } from '../Features/Classification/enum/NewsStatus';
import { JournalistModel } from './JournalistModel';

export interface InfluencerModel {
  id: number;
  uploadDate: string;
  objetivoUso: string;
  dataAnalise: string;
  validadeAnalise: string;
  dataValida1: string;
  dataRecebimento: string;
  prazoEntrega: string;
  comentarioReputacao: string;
  linksReferencia: string;
  solicitanteMarca: string;
  parecerMaquina: string;
  recomendacaoMaquina: string;
  evidencias: string;
  nivelRisco: string;
  id_usuario: number;
  usuario: string;
  nome: string;
  observacaoStatus: string;
  observacoes: string;
  observacaoRejeicao: string;
  pagoOrganico: string;
  tipoPerfil: string;
  url_perfil: string;
  id_solicitante: string;
  campanha: string;
  finalidade: string;
  canais: string | any;
  canaisICE: string | any;
  abrangencia: string;
  rtb: string;
  tamanho: null;
  territorio: null;
  preavaliacao: string;
  notifications: [];
  invalid: string;
  valid: string;
  spreadsheetId: null;
  newsId: null;
  journalistsSpreadsheet: null;
  media: null;
  marca: string;
  formato: string;

  questions: Array<{
    question: Array<{
      value: string;
      description: string;
    }>;
  }>;
  answers: [
    {
      value: string;
      id: number;
    }
  ];
  statusClassificacao: number;
  statusAuxClassificacao: '';
  statusRevisor: number;

  title: string;
  centimeter: number;
  clientId: number;
  clientDescription?: string;
  clipperId: number;
  clipperLink: string;
  journalistSpreadsheetName: string;
  journalists: JournalistModel[];
  newsLink: string;
  vehicle: string;
  publishDate: Date | null;
  clientCodeMetric: number | null;

  vehicleCodeMetric: number | null;
  mediaCodeMetric: number | null;
  vehicleId: number | null;
  mediaId: number | null;
  vehicleOriginDictionary: boolean;
  status: NewsStatus;

  metricIds?: string;
  classificationId: number | null;
  classificationStatus: ClassificationStatus | null;

  detached: boolean;
  area: string;
  vp: string;
  iniciativa: string;
  responsavelReputacao: string;
  objetivoContratacao: string;
  analiseReputacional: string;
  email: string;
  nivel_risco: string;

  marcaId: number | undefined;
  areaId: number | undefined;
  vpId: number | undefined;
  formatoId: number;
  finalidadeId: number;
  canaisId: { id_aux: number }[];
  abrangenciaId: number;
  territorioId: number | undefined;
  tamanhoId: number;
  nivelRiscoId: number;
}

export const newsModelInitial: InfluencerModel = {
  id: 0,
  id_usuario: 0,
  uploadDate: '',
  area: '',
  vp: '',
  formato: '',
  canais: '',
  abrangencia: '',
  observacoes: '',
  observacaoRejeicao: '',
  iniciativa: '',
  dataAnalise: '',
  dataRecebimento: '',
  prazoEntrega: '',
  comentarioReputacao: '',
  responsavelReputacao: '',
  analiseReputacional: '',
  objetivoContratacao: '',
  linksReferencia: '',
  parecerMaquina: '',
  recomendacaoMaquina: '',
  evidencias: '',
  nivelRisco: '',
  solicitanteMarca: '',
  territorio: null,
  validadeAnalise: '',
  dataValida1: '',
  objetivoUso: '',
  usuario: '',
  url_perfil: '',
  id_solicitante: '',
  campanha: '',
  finalidade: '',
  rtb: '',
  answers: [
    {
      value: '',
      id: 0,
    },
  ],
  tamanho: null,
  preavaliacao: '',
  notifications: [],
  invalid: '',
  valid: '',
  spreadsheetId: null,
  newsId: null,
  journalistsSpreadsheet: null,
  media: null,
  marca: '',

  questions: [
    {
      question: [],
    },
  ],
  statusClassificacao: 0,
  statusAuxClassificacao: '',
  statusRevisor: 0,

  title: '',
  nome: '',
  observacaoStatus: '',
  pagoOrganico: '',
  tipoPerfil: '',
  centimeter: 0,
  clientId: 0,
  clipperId: 0,
  clipperLink: '',
  journalistSpreadsheetName: '',
  newsLink: '',
  vehicle: '',
  publishDate: null,
  vehicleCodeMetric: 0,
  mediaCodeMetric: 0,
  vehicleId: 0,
  mediaId: 0,
  vehicleOriginDictionary: false,
  status: 0,
  clientCodeMetric: null,
  journalists: [],
  classificationId: null,
  classificationStatus: null,
  detached: false,
  email: '',
  nivel_risco: '',

  marcaId: 0,
  areaId: 0,
  vpId: 0,
  formatoId: 0,
  canaisId: [],
  finalidadeId: 0,
  abrangenciaId: 0,
  territorioId: 0,
  tamanhoId: 0,
  nivelRiscoId: 0,
  canaisICE: '',
};
